import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { useMutation } from '@apollo/client/react';
import { useCallback } from 'react';

import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';

import type {
  UpdateUserSettingsLocaleMutation,
  UpdateUserSettingsLocaleMutationVariables,
} from './__generated__/useSetUserSettingsLocale.graphql.ts';

const UPDATE_USER_SETTINGS_LOCALE_MUTATION = gql`
  mutation UpdateUserSettingsLocaleMutation($input: updateUserSettingsInput!) {
    updateUserSettings(input: $input) {
      userSettings {
        id
        locale
      }
      errors {
        path
        message
        code
      }
    }
  }
` as TypedDocumentNode<
  UpdateUserSettingsLocaleMutation,
  UpdateUserSettingsLocaleMutationVariables
>;

export const useSetUserSettingsLocale = () => {
  const { currentUser } = useCurrentUserContext();
  const [mutate] = useMutation(UPDATE_USER_SETTINGS_LOCALE_MUTATION);

  const setUserSettingsLocale = useCallback(
    (locale: string) => {
      if (currentUser) {
        mutate({ variables: { input: { locale } } });
      }
    },
    [currentUser, mutate]
  );

  return setUserSettingsLocale;
};
